<span class="form-field-wrapper --{{ size }}">
    <ng-content></ng-content>
</span>
